import { lazy } from "react";
import { Routes as RoutesType } from "../../types";
import { ROUTES } from "../../constants/routes";

export const mobileRoutes: RoutesType = [
  {
    key: "website.mobile.about_us",
    path: ROUTES.MOBILE_ABOUT_US,
    component: lazy(() => import("../../pages/mobile/about")),
    roles: [],
  },
  {
    key: "website.mobile.contact_us",
    path: ROUTES.MOBILE_CONTACT_US,
    component: lazy(() => import("../../pages/mobile/contact")),
    roles: [],
  },
  {
    key: "website.mobile.mobile_articles",
    path: ROUTES.MOBILE_ARTICLES,
    component: lazy(() => import("../../pages/mobile/articles")),
    roles: [],
  },
  {
    key: "website.mobile.mobile_articles_details",
    path: ROUTES.MOBILE_ARTICLES_DETAILS,
    component: lazy(() => import("../../pages/mobile/articles/[id]")),
    roles: [],
  },
  {
    key: "website.mobile.mobile_privacy_policy",
    path: ROUTES.MOBILE_PRIVACY_POLICY,
    component: lazy(() => import("../../pages/mobile/privacyPolicy")),
    roles: [],
  },
];
